import { useEffect, useState } from 'react'
import Loading from '../Loading/Loading'
import { references, successionPlanTranslate } from '../../i18n/translatedMessages'
import { AiOutlineDashboard, AiOutlineHolder } from 'react-icons/ai'
import { RiRobot2Line } from 'react-icons/ri'
import { GoArrowUp, GoArrowUpRight } from 'react-icons/go'
import { IoIosAlert } from 'react-icons/io'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

import { translate as translateAreas } from '../../i18n/Library/areasCorrelation.js'
import { translate as translatePosition } from '../../i18n/Library/hierarchicalLevel'
import { translate as translateSubareas } from '../../i18n/Library/subareasTranslate'
import { useIntl } from 'react-intl'

const scoreRanges = [
	{ min: 90, max: 200, color: 'tw-text-green-500' },
	{ min: 60, max: 89, color: 'tw-text-blue-500' },
	{ min: 30, max: 59, color: 'tw-text-alert-500' },
	{ min: 0, max: 29, color: 'tw-text-error-500' },
]

export const TableSuccessionPlan = ({ loading, employees, setEmployees, lists, handleAddNextStepClick }) => {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'
	const [isRankTooltipVisible, setIsRankTooltipVisible] = useState(false)
	const [isAvaliationTooltipVisible, setIsAvaliationTooltipVisible] = useState(false)
	const [tooltipIndex, setTooltipIndex] = useState(null)

	const [draggingIndex, setDraggingIndex] = useState(null)
	const rankedEmployees = [...employees].sort((a, b) => b.algorithm_score - a.algorithm_score)

	const getRank = algorithm_score => {
		return rankedEmployees.findIndex(candidate => candidate.algorithm_score === algorithm_score) + 1
	}

	const handleDragStart = index => {
		setDraggingIndex(index)
	}

	const handleDragOver = (event, index) => {
		event.preventDefault() // Impede o comportamento padrão

		const draggedOverItem = employees[index]

		if (draggingIndex === index) return

		const items = employees.filter((_, idx) => idx !== draggingIndex)
		items.splice(index, 0, employees[draggingIndex])

		setEmployees(items)
		setDraggingIndex(index)
	}

	const handleDragEnd = () => {
		setDraggingIndex(null)
	}

	const getScoreColor = score => {
		return scoreRanges.find(({ min, max }) => score >= min && score <= max)?.color || 'tw-text-gray-500'
	}

	return (
		<>
			<div className='tw-pr-20 tw-flex tw-items-center'>
				<table className='tw-w-full tw-bg-white border border-grey tw-border-gray-200'>
					<thead>
						<tr className='tw-bg-gray-100'>
							<th className='tw-px-2 tw-py-4 tw-text-left tw-font-bold'></th>
							<th className='tw-px-4 tw-py-4 tw-text-left tw-font-bold'>
								{successionPlanTranslate.successionPlanTableRank}
								<div
									className='tw-inline-block tw-relative tw-ml-2'
									onMouseEnter={() => setIsRankTooltipVisible(true)}
									onMouseLeave={() => setIsRankTooltipVisible(false)}
								>
									<IoIosAlert size={20} className='tw-text-gray-500 cursor-pointer' />
									{isRankTooltipVisible && (
										<span className='tw-absolute tw-bg-gray-900 tw-text-white tw-text-xs tw-rounded tw-p-1 tw-text-center tw-w-[250px] tw-left-1/2 tw-transform tw--translate-x-1/2 tw-bottom-full tw-mb-2'>
											{successionPlanTranslate.tooltipRank}
										</span>
									)}
								</div>
							</th>
							<th className='tw-px-4 tw-py-4 tw-text-left tw-font-bold'>{successionPlanTranslate.successionPlanTableName}</th>
							<th className='tw-px-4 tw-py-4 tw-text-left tw-font-bold'>
								{successionPlanTranslate.successionPlanTableAvaliation}
								<div
									className='tw-inline-block tw-relative tw-ml-2'
									onMouseEnter={() => setIsAvaliationTooltipVisible(true)}
									onMouseLeave={() => setIsAvaliationTooltipVisible(false)}
								>
									<IoIosAlert size={20} className='tw-text-gray-500 cursor-pointer' />
									{isAvaliationTooltipVisible && (
										<span className='tw-absolute tw-bg-gray-900 tw-text-white tw-text-xs tw-rounded tw-p-1 tw-text-center tw-w-[250px] tw-left-1/2 tw-transform tw--translate-x-1/2 tw-bottom-full tw-mb-2'>
											{successionPlanTranslate.tooltipAvaliation}
										</span>
									)}
								</div>
							</th>
							<th className='tw-px-4 tw-py-4 tw-text-left tw-font-bold'>{successionPlanTranslate.successionPlanTableNextStep}</th>
							<th className='tw-px-4 tw-py-4 tw-text-left tw-font-bold'>{successionPlanTranslate.successionPlanTablePontuation}</th>
						</tr>
					</thead>
					<tbody>
						{loading ? (
							<tr>
								<td colSpan='6'>
									<div className='tw-flex tw-justify-center tw-items-center tw-h-[200px]'>
										<Loading />
									</div>
								</td>
							</tr>
						) : employees.length === 0 ? (
							<tr>
								<td colSpan='6'>
									<div className='tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-[200px]'>
										<div className='tw-font-bold tw-text-xl tw-mb-2'>{successionPlanTranslate.successionPlanTableText1}</div>
										<div className='tw-text-purple-500 tw-text-center tw-font-semibold tw-max-w-[400px]'>
											{successionPlanTranslate.successionPlanTableText2}
											<span className='tw-text-gray-500'> {successionPlanTranslate.successionPlanTableText3}</span>
										</div>
									</div>
								</td>
							</tr>
						) : (
							[...employees]
								.sort((a, b) => a.name.localeCompare(b.name))
								.map((item, index) => (
									<tr
										key={item.employee_id}
										className='tw-border-b tw-cursor-move'
										draggable
										onDragStart={() => handleDragStart(index)}
										onDragOver={event => handleDragOver(event, index)}
										onDragEnd={handleDragEnd}
									>
										<td className='tw-px-2 tw-ml-2 tw-py-6'>
											<AiOutlineHolder size={28} className='tw-text-gray-500' />
										</td>
										<td className='tw-px-4 tw-py-6'>
											<div className='tw-flex tw-space-x-3 tw-items-center'>
												<div className='tw-font-bold'>{index + 1}</div>
												<div
													className='tw-relative tw-cursor-pointer tw-bg-gray-100 tw-pt-1 tw-px-3 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-text-gray-500'
													onMouseEnter={() => setTooltipIndex(index)}
													onMouseLeave={() => setTooltipIndex(null)}
												>
													<RiRobot2Line className='tw-text-gray-500 tw-mr-2' />
													{getRank(item.algorithm_score)}º
													{tooltipIndex === index && (
														<span className='tw-absolute tw-bg-gray-900 tw-text-white tw-text-xs tw-rounded tw-p-2 tw-w-[526px] tw-left-full tw-top-1/2 tw-transform tw--translate-y-1/2 tw-ml-2'>
															{successionPlanTranslate.tooltipScore}
														</span>
													)}
												</div>
											</div>
										</td>
										<td className='tw-px-4 tw-py-6'>
											<div className='tw-flex tw-items-center'>
												<div className='tw-w-10 tw-h-10 border tw-rounded-full tw-mr-2 tw-flex tw-items-center tw-justify-center tw-text-purple-500 tw-font-bold'>
													{item.name.charAt(0).toUpperCase()}
												</div>
												<div>
													<Link to={`/app/analytic/futurecv/${item.employee_id}`}>
														<div className='tw-text-purple-500 tw-font-semibold'>
															{item.name} <GoArrowUpRight />
														</div>
													</Link>

													<div className='tw-text-gray-500'>{item.jobname}</div>
													{item.employee_interest === true ? (
														<div className='tw-inline-block tw-text-sm tw-text-blue-900 tw-bg-blue-100 tw-px-2 tw-py-1 tw-rounded-full'>
															Interesado
														</div>
													) : null}
												</div>
											</div>
										</td>
										<td className='tw-px-4 tw-py-6'>
											<div>
												{references.performanceTitle}: {Math.floor(item.performance)}
											</div>
											<div>Potencial: {Math.floor(item.potential)}</div>
										</td>
										<td className='tw-px-4 tw-py-6'>
											<div className='tw-flex tw-flex-col tw-space-y-2'>
												{item.next_steps_hr.slice(0, 3).map((nextStep, index) => {
													const nextLevel = lists.levels.find(level => String(level.id) === String(nextStep.level_id))
													const nextSubarea = lists.subareas.find(subarea => String(subarea.id) === String(nextStep.subarea_id))
													const translatedSubareas = translateSubareas[language][nextSubarea?.value]
													const translatedLevel = translatePosition[language][nextLevel?.value]

													return (
														<div key={index} className='tw-flex tw-items-center tw-text-sm'>
															<GoArrowUp className='tw-text-purple-500 tw-mr-1' />
															{`${translatedLevel} de ${translatedSubareas}`}
														</div>
													)
												})}

												<div className='tw-text-purple-500 tw-text-sm tw-cursor-pointer' onClick={() => handleAddNextStepClick(item)}>
													+ {successionPlanTranslate.addNextStep}
												</div>
											</div>
										</td>
										<td className={`tw-px-4 tw-py-6`}>
											<div className={` ${getScoreColor(item.score)} tw-flex tw-items-center tw-font-semibold`}>
												<AiOutlineDashboard size={20} className={`${getScoreColor(item.algorithm_score)} tw-mr-2`} />
												{item.algorithm_score.toFixed()} %
											</div>
										</td>
									</tr>
								))
						)}
					</tbody>
				</table>
			</div>
		</>
	)
}
